module.exports = __webpack_public_path__ + "img/logo-white.6f9841c6.png";